import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Alert from "components/alert-view";
import {
  defineMessages,
  FormattedMessage,
} from "react-intl";
import appconfig from "config/appconfig";
import classes from "components/alert.scss";
import { InfoFilledIcon } from '@getgo/chameleon-icons/react';
import { Button ,Typography } from "@getgo/chameleon-web-react-wrapper";
import useAnalyticsHelpers from "lib/analytics-helpers";

const messagesConfig = {
  userIsConflicted: {
    messageType: appconfig.alertTypes.INFO,
    showIcon: true,
    iconClass: <InfoFilledIcon />,
    bodyResourceId: "messages.userIsConflicted.body",
    showButton: true,
    buttonTextId: "messages.userIsConflicted.button",
  },
};

const t = defineMessages({
  "messages.userIsConflicted.body": {
    id: "messages.userIsConflicted.body",
    defaultMessage:
      "Profile settings are currently locked. Please sign out and follow the login flow to update your account.",
  },
  "messages.userIsConflicted.button": {
    id: "messages.userIsConflicted.button",
    defaultMessage: "Sign out",
  },
});

const MessageBanner = ({ handleAlertDismiss, messageId, params }) => {
  const { track } = useAnalyticsHelpers();

  useEffect(() => {
    track('Alert Shown', {
      alertType: messageId,
      alertMessage: messagesConfig[messageId].bodyResourceId,
    });
  }, [messageId, track]);

  const handleButtonClick = () => {
    track('Alert Action Clicked', {
      alertType: messageId,
      action: messagesConfig[messageId].buttonTextId,
    });
    if (params.onclick) {
      params.onclick();
    }
  };

  const handleDismissClick = () => {
    track('Alert Dismissed', {
      alertType: messageId,
    });
    if (params.onDismiss) {
      params.onDismiss();
    } else {
      handleAlertDismiss();
    }
  };

  return (
    <Alert
      type={messagesConfig[messageId].messageType || appconfig.alertTypes.INFO}
      icon={messagesConfig[messageId].iconClass}
      body={
        <Typography>
          <span className={classes.bannerMessageText}>
            <FormattedMessage
              {...t[messagesConfig[messageId].bodyResourceId]}
              values={params}
            />
          </span>
        </Typography>
      }
      action={
        messagesConfig[messageId].showButton && (
          <Button
            id="banner-button"
            size="small"
            variant="neutral"
            className={classes.bannerMessageCTA}
            onClick={handleButtonClick}
          >
            <FormattedMessage {...t[messagesConfig[messageId].buttonTextId]} />
          </Button>
        )
      }
      handleDismiss={handleDismissClick}
      isCloseButton={params.isCloseButton}
    />
  );
};


MessageBanner.propTypes = {
  handleAlertDismiss: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
  params: PropTypes.object,
};

export default MessageBanner;
